
<template>
  <div>
    <div style="margin:0 auto;width:0px;height:0px;overflow:hidden;">
      <img src="./image/0.jpeg" width="700" />
    </div>
    <section id="activity-detail" class="pc_device">
      <div class="page-bizinfo">
        <div class="header">
          <h1 id="activity-name">如何查看MAC地址</h1>
        </div>
      </div>
      <div id="page-content" class="page-content">
        <div class="text">
          <p>
            <span style="color: rgb(255, 0, 0);">
              <strong>
                <span style="font-size: 16px;">MAC地址一般有2个地方可以找到：</span>
              </strong>
            </span>
          </p>
          <p>
            <span style="color: rgb(255, 0, 0);">
              <strong>
                <span style="color: rgb(255, 0, 0); font-size: 16px;">a、路由器背面的铭牌上，会明确标注“MAC”，如下图：</span>
              </strong>
            </span>
          </p>
          <p>
            <img src="./image/2.png" />
            <br />
          </p>
          <p>
            <span style="color: rgb(255, 0, 0);">
              <strong>
                <span style="font-size: 16px;">b、路由器的控制界面，如下图：</span>
              </strong>
            </span>
          </p>
          <p>
            <img src="./image/3.png" />
          </p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'newfindMac'
}
</script>



  <style  scoped>
td {
  margin: 0;
  padding: 0;
}

html,
body {
  height: 100%;
}

body {
  color: #222;
  font-size: 14px;
  font-family: "microsoft yahei";
  position: relative;
}

blockquote {
  padding-left: 10px;
  border-left: 3px solid #dbdbdb;
}

#activity-detail {
  max-width: 640px;
  /*min-height: 100%;*/
  margin: 0 auto;
  padding: 0 40px;
  background-color: #fff;
}

.follow-area {
  max-width: 720px;
  margin: 0 auto;

  background-color: #fff;
}

.page-bizinfo {
  padding: 25px 0;
}

pre {
  word-break: break-all;
  word-wrap: break-word;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

fieldset,
img {
  border: 0;
}

address,
caption,
cite,
code,
dfn,
th,
var {
  font-style: normal;
  font-weight: normal;
}

caption,
th {
  text-align: left;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: 100%;
  font-weight: normal;
}

q:before,
q:after {
  content: "";
}

abbr,
acronym {
  border: 0;
  font-variant: normal;
}

sup {
  vertical-align: text-top;
}

sub {
  vertical-align: text-bottom;
}

input,
textarea,
select {
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
}

input,
textarea,
select {
  font-size: 100%;
}

legend {
  color: #000;
}

.activity-info {
  line-height: 20px;
}

.activity-meta {
  display: inline-block;
  color: #66686c;
  margin-right: 10px;
  margin-bottom: 10px;
  font-size: 15px;
}

.activity-meta:empty {
  display: none;
}

.pc_device .activity-meta {
  font-size: 14px;
}

.activity-info .text-ellipsis {
  float: left;
  margin-bottom: 25px;
}

.activity-info .text-ellipsis a {
  display: inline-block;
  max-width: 290px;
  height: 1.2em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

#post-user {
  text-decoration: none;
  outline: 0;
  color: #0067ed;
  cursor: text;
  font-size: 15px;
}

a.activity-meta {
  text-decoration: none;
  outline: 0;
  color: #607fa6;
}

#activity-detail .page-content {
  word-wrap: break-word;
  word-break: break-all;
}

div#page-content * {
  max-width: 100% !important;
}

#activity-detail .page-content .media {
  margin: 0 0 6px 0;
}

#activity-detail .page-content .media img {
  width: 100%;
}

#activity-detail .page-content .text {
  color: #1e2330;
  line-height: 28px;
}


#activity-detail .page-content .text p:after {
  content: " ";
  display: block;
  height: 0;
  clear: both;
}

#activity-detail .video-frame {
  width: 100% !important;
  overflow: hidden;
}

.page-toolbar {
  padding-bottom: 20px;
  overflow: hidden;
  padding-top: 20px;
  *zoom: 1;
}

.page-toolbar a {
  color: #0067ed;
  text-decoration: none;
  text-shadow: 0 1px #fff;
  -webkit-text-shadow: 0 1px #ffffff;
  -moz-text-shadow: 0 1px #ffffff;
}

.text {
  padding-bottom: 30px;
}

.text p {
  margin: 0px 0;
  padding: 0px;
  line-height: 10px;
}

.text p span {
  line-height: 30px;
}

.text img {
  max-width: 100% !important;
  height: auto !important;
}

.text li {
  word-wrap: break-word;
}

@media only screen and (min-device-width: 720px) {
  .follow-area {
    padding: 0 15px;
  }
}

/*@media only screen and (min-device-width: 320px) and (max-device-width: 700px) {*/
body {
  font-size: 12px;
  font-family: "Helvetica Neue", Helvetica, "Hiragino Sans GB",
    "Microsoft YaHei", Arial, sans-serif;
}

.pc_device * {
  font-family: "Microsoft YaHei", "Helvetica Neue", Helvetica, Arial, sans-serif !important;
}

#activity-name {
  font-size: 20px;
  color: #333;
  text-align: center;
  line-height: 20px;
  margin-bottom: 10px;
}

/* #activity-name {
      color: #000;
      font-size: 24px;
      font-weight: normal;
      word-break: normal;
      word-wrap: break-word;
      margin-bottom: 15px;
    } */

#activity-detail {
  padding: 0 15px;
}

.page-bizinfo {
  padding-top: 15px;
  padding-bottom: 10px;
}

.pc_device .page-bizinfo {
  padding-top: 30px;
}

.text {
  font-size: 16px;
  color: #1e2330;
  line-height: 30px;
}

.original_link {
  font-size: 15px;
  color: #00a5e0;
  padding-bottom: 17px;
}

.follow-area {
  height: 80px;
  background: transparent;
  position: relative;
  border-top: 1px solid #ededed;
  border-bottom: 1px solid #ededed;
}

#follow-content {
  padding-top: 15px;
  position: relative;
}

.icon-area {
  position: absolute;
  left: 0;
}

.right-area {
  position: absolute;
  right: 0;
  top: 25px;
}

.logo-pic {
  width: 51px;
  height: 51px;
  border-radius: 50%;
}

.right-area .action-button {
  height: 30px;
  width: 70px;
  font-size: 14px;
  border-radius: 6px;
  background: transparent;
  vertical-align: middle;
  line-height: 28px;
  padding: 0;
}

.follow-button {
  color: #00a2e0;
  border: 1px solid #00a2e0;
  background-size: 70px 30px;
}

.inner-text {
  vertical-align: middle;
  line-height: 30px;
  white-space: nowrap;
}

.title-center {
  /*margin-top: 15px;*/
  line-height: 52px;
  vertical-align: middle;
}

.button-icon {
  display: inline-block;
  height: 12px;
  width: 12px;
  vertical-align: middle;
  background-size: contain;
  background-repeat: no-repeat;
}

.icon-cross {
  background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+PHN2ZyB3aWR0aD0iMjBweCIgaGVpZ2h0PSIyMHB4IiB2aWV3Qm94PSIwIDAgMjAgMjAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeG1sbnM6c2tldGNoPSJodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2gvbnMiPiAgICAgICAgPHRpdGxlPlJlY3RhbmdsZSAzICsgUmVjdGFuZ2xlIDM8L3RpdGxlPiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4gICAgPGRlZnM+PC9kZWZzPiAgICA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBza2V0Y2g6dHlwZT0iTVNQYWdlIj4gICAgICAgIDxnIGlkPSJSZWN0YW5nbGUtMy0rLVJlY3RhbmdsZS0zIiBza2V0Y2g6dHlwZT0iTVNMYXllckdyb3VwIiBmaWxsPSIjMDBBMkUwIj4gICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlLTMiIHNrZXRjaDp0eXBlPSJNU1NoYXBlR3JvdXAiIHg9IjkiIHk9IjAiIHdpZHRoPSIyIiBoZWlnaHQ9IjIwIj48L3JlY3Q+ICAgICAgICAgICAgPHBhdGggZD0iTTIwLDkgTDIwLDExIEwwLDExIEwwLDkgTDIwLDkgTDIwLDkgWiIgaWQ9IlJlY3RhbmdsZS0zIiBza2V0Y2g6dHlwZT0iTVNTaGFwZUdyb3VwIj48L3BhdGg+ICAgICAgICA8L2c+ICAgIDwvZz48L3N2Zz4=);
}

.icon-check {
  background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+PHN2ZyB3aWR0aD0iMjFweCIgaGVpZ2h0PSIxNXB4IiB2aWV3Qm94PSIwIDAgMjEgMTUiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeG1sbnM6c2tldGNoPSJodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2gvbnMiPiAgICAgICAgPHRpdGxlPlJlY3RhbmdsZSA0PC90aXRsZT4gICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+ICAgIDxkZWZzPjwvZGVmcz4gICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc2tldGNoOnR5cGU9Ik1TUGFnZSI+ICAgICAgICA8cGF0aCBkPSJNMjAuMzUyNjY0NywxLjMwMzQ0MzM0IEw3LjQxMTQ4MTM5LDE0LjI0NDYyNjYgTDAsNi44MzMxNDUyNSBMMS4zMTQ1NzY2Miw1LjUxODU2ODYzIEw3LjQzMTc5NDkyLDExLjYzNTc4NjkgTDE5LjA2NzU4MTksMCIgaWQ9IlJlY3RhbmdsZS00IiBmaWxsPSIjMDBBQjc5IiBza2V0Y2g6dHlwZT0iTVNTaGFwZUdyb3VwIj48L3BhdGg+ICAgIDwvZz48L3N2Zz4=);
  /*background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+PHN2ZyB3aWR0aD0iMjBweCIgaGVpZ2h0PSIyMHB4IiB2aWV3Qm94PSIwIDAgMjAgMjAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeG1sbnM6c2tldGNoPSJodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2gvbnMiPiAgICAgICAgPHRpdGxlPlJlY3RhbmdsZSAzICsgUmVjdGFuZ2xlIDM8L3RpdGxlPiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4gICAgPGRlZnM+PC9kZWZzPiAgICA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBza2V0Y2g6dHlwZT0iTVNQYWdlIj4gICAgICAgIDxnIGlkPSJSZWN0YW5nbGUtMy0rLVJlY3RhbmdsZS0zIiBza2V0Y2g6dHlwZT0iTVNMYXllckdyb3VwIiBmaWxsPSIjMDBBMkUwIj4gICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlLTMiIHNrZXRjaDp0eXBlPSJNU1NoYXBlR3JvdXAiIHg9IjkiIHk9IjAiIHdpZHRoPSIyIiBoZWlnaHQ9IjIwIj48L3JlY3Q+ICAgICAgICAgICAgPHBhdGggZD0iTTIwLDkgTDIwLDExIEwwLDExIEwwLDkgTDIwLDkgTDIwLDkgWiIgaWQ9IlJlY3RhbmdsZS0zIiBza2V0Y2g6dHlwZT0iTVNTaGFwZUdyb3VwIj48L3BhdGg+ICAgICAgICA8L2c+ICAgIDwvZz48L3N2Zz4=);*/
}

.line-contain {
  display: inline;
}

.wpa-container {
  display: inline-block;
  position: relative;
  width: 100%;
  height: 115px;
  padding: 10px;
}

.theme-2 {
  background: #fff;
  box-shadow: 0 0 0 1px #bbb;
}

.theme-1 {
  background: #19212d;
}

.qr-code,
.info,
.title {
  display: inline-block;
}

.img-avatar {
  display: none;
}

.qr-code {
  padding: 8px;
  background: #fff;
  position: relative;
  width: 100px;
  height: 100px;
}

.qr-code-img {
  width: 100px;
  height: 100px;
}

.theme-2 .qr-code {
  padding: 0;
  width: 115px;
  height: 115px;
}

.theme-2 .qr-code-img {
  width: 115px;
  height: 115px;
}

.avatar-in-qr-code {
  width: 35px;
  height: 35px;
  position: absolute;
  top: 40px;
  left: 40px;
  display: none;
}

.info {
  position: absolute;
  left: 135px;
  top: 24px;
}

.avatar img {
  border-radius: 50%;
  width: 40px;
  height: 40px;
  vertical-align: middle;
}

.title {
  font-size: 16px;
  vertical-align: middle;
  color: #fff;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.signature {
  font-size: 14px;
  max-width: 80%;
  margin-top: 17px;
  color: #fff;
  word-break: break-all;
}

.theme-2 .signature {
  color: #999;
}

.theme-2 .title {
  color: #000;
}

.unableView {
  width: 400px;
  margin: auto;
  text-align: center;
}

.unableView img {
  width: 240px;
  height: 180px;
}

.unableView-info {
  font-family: "PingFangSC-Regular";
  font-size: 30px;
  color: #1e2330;
  letter-spacing: 0;
  line-height: 42px;
  margin-top: 24px;
}

@media screen and (max-device-width: 720px) {
  .unableView {
    width: 200px;
    margin: auto;
  }

  .unableView img {
    width: 200px;
    height: 150px;
    margin: auto;
  }

  .unableView-info {
    font-size: 16px;
    line-height: 25px;
    margin-top: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// findMac.vue?639a6a18